import { NAME } from './constants';

export const INITIALIZE_MAP_FILTER = `${NAME}/initializeFilter`;
export const TOGGLE_MAP_FILTER = `${NAME}/toggleFilter`;
export const SET_MAP_VIEW = `${NAME}/setMapView`;
